import { AdminSearchApplications } from "../components/AdminSearchApplications";
export function AdminDenialConfAdmission() {
    document.title = `Търсене - Отписване`;
    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1 className="use-font">Отказ от потвърден прием</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Отказ от потвърден прием</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">
                        <div className="row">
                            <AdminSearchApplications action='deny' />
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminDenialConfAdmission;